import { initRankingCreateDisclosure } from './rankings/create-disclosure.js';
import { initRankingDeleteConfirm } from './rankings/delete-confirm.js';
import { initRankingEarlierYears } from './rankings/earlier-years.js';
import { initRankingEditMode } from './rankings/edit-mode.js';
import { initRankingNotes } from './rankings/notes-ambient.js';

(function () {
    initRankingCreateDisclosure();
    initRankingEarlierYears();
    // The editing mode owns drag-to-reorder, because it owns every swap of the positions list.
    initRankingEditMode();
    initRankingNotes();
    initRankingDeleteConfirm();
})();
